import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '../Button';

const PIN_LENGTH = 4;

class SubmitPIN extends Component {
  constructor() {
    super();
    this.changeInput = this.changeInput.bind(this);
    this.submitPIN = this.submitPIN.bind(this);
    this.state = {
      pinProvided: '',
      pinFilledArray: Array(PIN_LENGTH).fill(0)
    };
  }

  changeInput(event) {
    const value = event.target.value.toString();

    if (!/^\d*$/.test(value) || value.length > PIN_LENGTH) {
      return;
    }

    const newArray = Array(PIN_LENGTH).fill(0).fill(1, 0, value.length);

    this.setState({
      pinProvided: value,
      pinFilledArray: newArray
    });
  }

  submitPIN(event) {
    this.props.onSubmit(this.state.pinProvided);
    this.setState({
      pinProvided: '',
      pinFilledArray: Array(PIN_LENGTH).fill(0)
    });
    event.preventDefault();
    return false;
  }

  render() {
    const { pinFilledArray, pinProvided } = this.state;
    const pinDotKeys = ['first', 'second', 'third', 'fourth'];

    return (
      <form className="submit-pin" onSubmit={this.submitPIN}>
        <div className="submit-pin__row">
          <input
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            className="submit-pin__input"
            type="tel"
            id="pinInput"
            onChange={this.changeInput}
            value={pinProvided}
            autoComplete="off"
          />
          <label
            className="submit-pin__input-label"
            htmlFor="pinInput"
          >
            {pinFilledArray.map((item, i) => (
              <i
                className={classNames('submit-pin__icon', 'material-icon', {
                  'material-icon--radio-checked': item,
                  'material-icon--radio-unchecked': !item
                })}
                key={`dot-${pinDotKeys[i]}`}
              />
            ))}
          </label>
        </div>

        <Button
          className="submit-pin__button"
          disabled={pinProvided.length !== pinFilledArray.length}
          onClick={this.submitPIN}
        >
          Confirm PIN
        </Button>
      </form>
    );
  }
}

SubmitPIN.propTypes = {
  onSubmit: PropTypes.func.isRequired
};

export default SubmitPIN;
